import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { Button } from 'foundations-components/transitional/components/Button';
import { CreditCardIcon } from 'foundations-assets/icons/components/CreditCardIcon';
import { BankIcon } from 'foundations-assets/icons/components/BankIcon';
import { useIsPillBorderRadius } from 'portals-platform-lib';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import { PAYMENT_METHOD_TYPE } from '../../utils/typeAdapters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function FailedPaymentCard({
  group
}) {
  const isPill = useIsPillBorderRadius();
  const tileProps = {
    'data-test-id': 'failed-payment-card',
    borderRadius: isPill ? '0' : '300'
  };
  const latestPayment = group.failedPayments[0];
  if (!latestPayment) {
    return null;
  }
  const details = latestPayment.paymentMethodDetails;
  const isCard = details.type === PAYMENT_METHOD_TYPE.CARD;
  return /*#__PURE__*/_jsx(Tile, Object.assign({}, tileProps, {
    children: /*#__PURE__*/_jsx(TileSection, {
      paddingBlock: "600",
      paddingInline: "600",
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "300",
        children: [/*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          children: [/*#__PURE__*/_jsx(StatusDot, {
            use: "danger"
          }), /*#__PURE__*/_jsx(Text, {
            typography: "detail-200",
            color: "text-core-subtle",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "failedPayments.status.failed"
            })
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          children: [isCard ? /*#__PURE__*/_jsx(CreditCardIcon, {
            size: "400"
          }) : /*#__PURE__*/_jsx(BankIcon, {
            size: "400"
          }), /*#__PURE__*/_jsx(Text, {
            typography: "heading-200",
            children: /*#__PURE__*/_jsx(FormattedIntlCurrency, {
              value: Number(latestPayment.amount),
              currencyCode: latestPayment.currencyCode
            })
          })]
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Text, {
            typography: "body-125",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "failedPayments.declineReason"
            })
          }), /*#__PURE__*/_jsx(Text, {
            typography: "body-100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "failedPayments.declineReasonValue"
            })
          })]
        }), /*#__PURE__*/_jsx(Button, {
          use: "primary",
          "data-test-id": "update-payment-method-btn",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "failedPayments.updatePaymentMethod"
          })
        })]
      })
    })
  }));
}